export default __webpack_public_path__ + "static/media/line.9e9f37b5.svg";